









import Vue from 'vue'
import Component from 'vue-class-component'

@Component<Avatar>({
  props: {
    icon: String,
    text: String
  }
})

export default class Avatar extends Vue {
  /**
   * Props variables
   */
  icon: string | undefined
  text: string | undefined
}
